import { Label } from '@fluentui/react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import '../../css/immocom.css';
import { DataIndicateur } from '../../data/DataIndicateur';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAnnee } from '../ComboBox/ComboBoxAnnee';
import { ComboBoxMois } from '../ComboBox/ComboBoxMois';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheCGReintegration } from '../Fiche/FicheCGReintegration';
import '../List/DetailsListCG.css';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListCGReintegration extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListCGReintegrationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListCGReintegrationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        dateDebutPeriodeOuverte: null,
        items: [],
        itemsSelectionnes: [],
        labelPeriode: "Période non ouverte",
        peutAccederSuiviBudgetaire: false,
        peutModifier: false,
        /* --- */
        afficherPanelFiltres: false,
        afficherPanelReintegration: false,
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListCGReintegrationWithPerimetre.defaultState };
        this._filtres = this._getFiltres();
        this._columns = this._getColumns();
        this._isSortedDescending = true;
        this._sortedColumn = "nomOperation";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState({
            afficherPanelFiltres: false,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _canEdit = (dateValeur, dateClotureCG, dateClotureNationaleCG) => {

        const { dateDebutPeriodeOuverte, peutModifier } = this.state;

        if (!peutModifier) return false;
        if (!dateDebutPeriodeOuverte) return false;

        if (Scriba.date().getDateFromChaineISO(dateValeur) >= Scriba.date().getDateFromChaineISO(dateDebutPeriodeOuverte)) {
            // Clôturée au niveau régional ou national => Pas de modification possible
            const dateClotureCGRenseignee = Scriba.formulaire().nEstPasVide(dateClotureCG);
            const dateClotureNationaleCGRenseignee = Scriba.formulaire().nEstPasVide(dateClotureNationaleCG);
            if (dateClotureCGRenseignee || dateClotureNationaleCGRenseignee) return false;
        }

        return true;

    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des indicateurs en cours'
        });

        const { filtreAnnee, filtreMois } = this._filtres;
        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataIndicateur._chargementListeDesINDICATEURSReintegration(tri, filtreMois, filtreAnnee, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const newItems = objetData[0] || [];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const peutAccederSuiviBudgetaire = objetData[1];
                const periodeOuverture = objetData[2];
                const peutModifier = objetData[3];

                let labelPeriode = "Période non ouverte";
                if (!!periodeOuverture.mois && !!periodeOuverture.annee)
                    labelPeriode = `Période en cours : ${periodeOuverture.mois} ${periodeOuverture.annee}`;

                const state = {
                    dateDebutPeriodeOuverte: periodeOuverture.dateDebut,
                    items,
                    labelPeriode,
                    peutAccederSuiviBudgetaire,
                    peutModifier
                };

                if (!filtreMois)
                    this._filtres.filtreMois = !!periodeOuverture.dateDebut ? parseInt(Scriba.date().stringDateFormat(periodeOuverture.dateDebut, 'M')) : 0;

                if (!filtreAnnee)
                    this._filtres.filtreAnnee = !!periodeOuverture.annee ? periodeOuverture.annee : 0;

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, { ...DetailsListCGReintegrationWithPerimetre.defaultState }, retourVerif, responseFetch);
        });

    };

    _getMoisEnCours = () => {
        const { filtreMois } = this._filtres;
        return Immocom.conversion().getMoisAPartirNumero(filtreMois);
    };

    _getColumns = () => {

        const moisEnCours = this._getMoisEnCours();
        const anneeEnCours = this._filtres.filtreAnnee;
        const moisAnneePrecedent = this._getMoisAnneePrecedent();

        return [{
            key: "nomOperation",
            name: "Opération",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "moisDate",
            maxWidth: 120,
            minWidth: 80,
            name: "Période",
        }, {
            ariaLabel: `Données d'engagement actualisées au 1er janvier ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nau 1er janvier ${anneeEnCours}`,
            key: "engagementNb_CumuleAnneeNMoins1",
            maxWidth: 90,
            minWidth: 45,
            name: "Nb lots",
        }, {
            ariaLabel: `Données d'engagement actualisées au 1er janvier ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nau 1er janvier ${anneeEnCours}`,
            key: "engagementSurface_CumuleAnneeNMoins1",
            maxWidth: 90,
            minWidth: 60,
            name: "SHA/SU",
            onRender: (item) => {
                const { engagementSurface_CumuleAnneeNMoins1 } = item;
                const formated = !!engagementSurface_CumuleAnneeNMoins1 || engagementSurface_CumuleAnneeNMoins1 === 0 ? parseFloat(engagementSurface_CumuleAnneeNMoins1).toFixed(2) + ' m²' : null;
                return <span title={formated}>{formated}</span>;
            }
        }, {
            ariaLabel: `Données d'engagement actualisées au 1er janvier ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nau 1er janvier ${anneeEnCours}`,
            key: "engagementCA_CumuleAnneeNMoins1",
            name: "CA HT"
        }, {
            ariaLabel: `Cumul réintégration à fin ${moisAnneePrecedent}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Cumul réintégration\nà fin ${moisAnneePrecedent}`,
            key: "reintegrationNb_CumuleMoisMMoins1PourAnneeN",
            maxWidth: 90,
            minWidth: 45,
            name: "Nb lots",
        }, {
            ariaLabel: `Cumul réintégration à fin ${moisAnneePrecedent}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Cumul réintégration\nà fin ${moisAnneePrecedent}`,
            key: "reintegrationSurface_CumuleMoisMMoins1PourAnneeN",
            maxWidth: 90,
            minWidth: 60,
            name: "SHA/SU",
            onRender: (item) => {
                const { reintegrationSurface_CumuleMoisMMoins1PourAnneeN } = item;
                const formated = !!reintegrationSurface_CumuleMoisMMoins1PourAnneeN || reintegrationSurface_CumuleMoisMMoins1PourAnneeN === 0 ? parseFloat(reintegrationSurface_CumuleMoisMMoins1PourAnneeN).toFixed(2) + ' m²' : null;
                return <span title={formated}>{formated}</span>;
            }
        }, {
            ariaLabel: `Cumul réintégration à fin ${moisAnneePrecedent}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Cumul réintégration\nà fin ${moisAnneePrecedent}`,
            key: "reintegrationCA_CumuleMoisMMoins1PourAnneeN",
            name: "CA HT",
        }, {
            ariaLabel: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            key: "reintegrationNb",
            maxWidth: 90,
            minWidth: 45,
            name: "Nb lots",
        }, {
            ariaLabel: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            key: "reintegrationSurface",
            maxWidth: 90,
            minWidth: 60,
            name: "SHA/SU",
            onRender: (item) => {
                const { reintegrationSurface } = item;
                const formated = !!reintegrationSurface || reintegrationSurface === 0 ? parseFloat(reintegrationSurface).toFixed(2) + ' m²' : null;
                return <span title={formated}>{formated}</span>;
            }
        }, {
            ariaLabel: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            headerName: `Réintégration\n${moisEnCours} ${anneeEnCours}`,
            key: "reintegrationCA",
            name: "CA HT",
        }, {
            ariaLabel: `Données d'engagement actualisées à fin ${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nà fin ${moisEnCours} ${anneeEnCours}`,
            key: "engagementNb_CumuleMoisM",
            maxWidth: 90,
            minWidth: 45,
            name: "Nb lots",
        }, {
            ariaLabel: `Données d'engagement actualisées à fin ${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nà fin ${moisEnCours} ${anneeEnCours}`,
            key: "engagementSurface_CumuleMoisM",
            maxWidth: 90,
            minWidth: 60,
            name: "SHA/SU",
            onRender: (item) => {
                const { engagementSurface_CumuleMoisM } = item;
                const formated = !!engagementSurface_CumuleMoisM || engagementSurface_CumuleMoisM === 0 ? parseFloat(engagementSurface_CumuleMoisM).toFixed(2) + ' m²' : null;
                return <span title={formated}>{formated}</span>;
            }
        }, {
            ariaLabel: `Données d'engagement actualisées à fin ${moisEnCours} ${anneeEnCours}`,
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            headerName: `Données d'engagement\nactualisées\nà fin ${moisEnCours} ${anneeEnCours}`,
            key: "engagementCA_CumuleMoisM",
            name: "CA HT",
        }, {
            isIconOnly: true,
            key: "edit",
            onRender: (item) => {
                const canEdit = this._canEdit(item.dateValeur, item.dateClotureCG, item.dateClotureNationaleCG);
                if (!canEdit) return null;
                else return <IconButton
                    iconProps={{ iconName: "Edit" }}
                    onClick={this._togglePanelReintegration(true, { itemsSelectionnes: [item] })}
                    title="Editer"
                />;
            }
        }];

    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getMoisAnneePrecedent = () => {
        const { filtreAnnee, filtreMois } = this._filtres;
        return Immocom.conversion().getMoisAPartirNumero(filtreMois === 1 ? 12 : filtreMois - 1) + ' ' + (filtreMois === 1 ? filtreAnnee - 1 : filtreAnnee);
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onScroll = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _togglePanelFiltres = (isOpen) => () => {
        this.setState({ afficherPanelFiltres: isOpen });
    };

    _togglePanelReintegration = (isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                afficherPanelReintegration: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //    this._chargementColonnes();
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
        this._columns = this._getColumns();
    };

    render = () => {

        const { filtreAnnee, filtreMois } = this._filtres;
        const {
            afficherPanelFiltres, afficherPanelReintegration,
            items, itemsSelectionnes, labelPeriode
        } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={!!filtreMois || !!filtreAnnee ? `Réservations / Désistements sur : ${Immocom.conversion().getMoisAPartirNumero(filtreMois)} ${filtreAnnee}` : ""}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <Sticky stickyPosition={StickyPositionType.Header}>
                <div className="labelPeriodeEnCours">{labelPeriode}</div>
            </Sticky>

            {this.state.peutAccederSuiviBudgetaire &&
                <EUIDetailsList
                    columns={this._columns}
                    getKey={item => item.compteur}
                    isSortedDescending={this._isSortedDescending}
                    items={items}
                    onColumnHeaderClick={this._onColumnHeaderClick}
                    onFilterButtonClick={this._togglePanelFiltres(true)}
                    onScroll={this._onScroll}
                    sortedColumn={this._sortedColumn}
                    selectionMode={SelectionMode.none}
                />
            }

            <FicheCGReintegration
                isOpen={afficherPanelReintegration}
                onDismiss={this._togglePanelReintegration(false)}
                onSave={this._togglePanelReintegration(false, {}, this._chargementDonnees)}
                operation={Array.isArray(itemsSelectionnes) && itemsSelectionnes.length > 0 ? itemsSelectionnes[0] : {}}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onDismiss={this._togglePanelFiltres(false)}
                onValidate={this._appliquerFiltres}
            />

        </Fragment>;

    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onValidate: () => null,
    };

    static defaultState = {
        filtreAnnee: 0,
        filtreMois: 0,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { filtreAnnee, filtreMois } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >
            <Label>Réservations / Désistements sur</Label>
            <ComboBoxMois
                onChange={(event, option) => this.setState({ filtreMois: option.key })}
                selectedKey={filtreMois}
            />
            <ComboBoxAnnee
                onChange={(event, option) => this.setState({ filtreAnnee: option.key })}
                selectedKey={filtreAnnee}
            />
        </EUIPanel>;

    };

};